import { useQuery } from "@tanstack/react-query";
import { API_RESERVE } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetReserve = <T>(params: { [key: string]: string | number }) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_RESERVE_INFO, params],
        queryFn: () => API_RESERVE.getReserveRoomInfo<T>(params),
    });

    return { data, isLoading };
};
